import script from "./OrganizationVocabularyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationVocabularyView.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationVocabularyView.vue?vue&type=style&index=0&id=fa99b538&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa99b538"]])

export default __exports__